import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CssStyleService {
  private readonly document = inject(DOCUMENT);

  cssVar(name: string): string {
    return getComputedStyle(this.document.documentElement).getPropertyValue(name).trim();
  }

  cssVarFn(name: string): () => string {
    return () => this.cssVar(name);
  }
}
